import React, { useEffect, useState } from 'react'
import { useObject } from 'react-firebase-hooks/database'
// import OfficeBearerModal from 'src/components/OfficeBearerModal'
// import OrganisingCommitteeModal from 'src/components/OrganisingCommiteeModal'
import styled from 'styled-components'
import ChatSection from '../../components/ChatSection.js'
import FacultySide from '../../components/FacultySide'
import LoadIcon from '../../components/LoadIcon'
import config from '../../config'
import { getHallChatDb, getHallQuestionDb, getLiveSessionDb } from '../../firebaseConfig'
import liveStream from '../../images/icons/live-tv.png'
import closeTheatre from '../../images/mobile/close-theatre.png'
import openTheatre from '../../images/mobile/open-theatre.png'
import screen from '../../images/mobile/screen.png'
import { COLORS } from '../../styles/theme'
import Amplitude from '../../utils/amplitudeHelper'
import { useAutoMute } from '../../utils/useAutoMute'
import banner from '../../images/backdrops/auditorium_banner.png'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router'
import routes from 'src/routes'
import { toast } from 'react-toastify'
import { getLiveSession } from 'src/ducks/liveSession.js'
import { isEmpty } from 'lodash'

const MobileAuditorium = ({ currentUser }) => {
  useAutoMute()
  const dispatch = useDispatch()
  const history = useHistory()
  const { sessionId } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [theatre, setTheatre] = useState(false)
  const [facultySide, setFacultySide] = useState(false)
  const [officeBearerModal, setOfficeBearerModal] = useState(false)
  const [organisingCommitteeModal, setOrganisingCommitteeModal] = useState(false)
  const [watchPlayBack, setWatchPlayBack] = useState(useLocation()?.search === '?playback')

  const { session } = useSelector((state) => state.liveSession)

  const [snapshot, snapshotLoading, snapshotError] = useObject(getLiveSessionDb(sessionId))

  useEffect(() => {
    if (!snapshotLoading && !snapshotError) {
      if (!snapshot.val()) {
        toast('The admin has closed this hall.', { toastId: 'sessionError' })
        history.push(routes.programme)
      } else {
        dispatch(getLiveSession(sessionId))
        Amplitude.watchLive(sessionId)
      }
    }
  }, [snapshotLoading, snapshot, history, currentUser.id, sessionId, dispatch])

  const toggleModal = (type) => {
    if (type == 'faculty') {
      setFacultySide(!facultySide)
    }
  }

  const videoContainerTheatreStyle = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'black',
    zIndex: '99',
  }
  if (isEmpty(session)) {
    return <LoadIcon />
  }

  const liveStreamComponent = (
    <>
      {session?.streamUrl ? (
        <div className="screen-container">
          <img src={screen} className="screen" alt="screen" />
          <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
            {isLoading && <LoadIcon />}
            <iframe
              title="Live Broadcast"
              src={`${session.streamUrl}?autoplay=1`}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
        </div>
      ) : (
        <div className="screen-container">
          <img src={screen} className="screen" alt="screen" />
          <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
            <div className="noStreamUrl">No stream URL for this session</div>
          </div>
        </div>
      )}
    </>
  )
  const playbackComponent = (
    <>
      {session?.playbackUrl ? (
        <div className="screen-container">
          <img src={screen} className="screen" alt="screen" />
          <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
            {isLoading && <LoadIcon />}
            <iframe
              title="Live Broadcast"
              src={`${session.playbackUrl}?autoplay=1`}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
        </div>
      ) : (
        <div className="screen-container">
          <img src={screen} className="screen" alt="screen" />
          <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
            <div className="noStreamUrl">No stream URL for this session</div>
          </div>
        </div>
      )}
    </>
  )

  return (
    <Page>
      <FacultySide open={facultySide} toggleSidebar={toggleModal} />
      {/* <OfficeBearerModal showOfficeBearer={officeBearerModal} setShowOfficeBearer={toggleModal} />
      <OrganisingCommitteeModal showOrganisingCommittee={organisingCommitteeModal} setShowOrganisingCommittee={toggleModal} /> */}

      <div className="outer-wrapper">
        <div className="container">
          <div id="sponsors" className='my-2'>
            <img src={banner} width="100%" alt="sponsors" />
          </div>

          <div id="tooltip">
            <img src={liveStream} width="15%" alt="screen" />
            <p className="tooltip-text">
              Live session is in progress. If you missed a session, click on ‘Programme’ to watch playback
            </p>
          </div>

          {watchPlayBack ? playbackComponent : liveStreamComponent}

          <button type="button" className="theatre-button" onClick={() => setTheatre(true)}>
            <img src={openTheatre} className="theatre-button-icon" alt="theatre-icon" />
            <p className="theatre-button-label">Theatre mode</p>
          </button>

          <div className="programme-wrap mb-3">
            <button className="action-button programme-btn" onClick={() => history.push(routes.programme)}>
              <small>PROGRAMME</small>
            </button>
            <button type="button" className="action-button faculty-btn" onClick={() => toggleModal('faculty')}>
              <small>FACULTY</small>
            </button>
          </div>
          {/* <div className="button-container">
            <button type="button" className="action-button" onClick={() => toggleModal('bearer')}>
              <small>MOA OFFICE BEARERS 2021 - 2022</small>
            </button>
            <button type="button" className="action-button" onClick={() => toggleModal('committee')}>
              <small>MOA ORGANISING AND SCIENTIFIC COMMITTEE</small>
            </button>
          </div> */}
        </div>

        <div className="chat-container">
          <ChatSection 
            currentUser={currentUser} 
            firebaseDb={getHallQuestionDb(sessionId)} 
            chatDb={getHallChatDb(sessionId)} 
          />
        </div>

        {theatre && (
          <div className="theatre-close">
            <img src={closeTheatre} onClick={() => setTheatre(false)} className="theatre-close-icon" alt="close-icon" />
          </div>
        )}
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: url(${config.assets.auditorium1.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 95%;
    margin: auto;
  }

  .programme-btn {
    margin-right: 10px;
  }

  .faculty-btn {
    margin-left: 10px;
  }
  .toggle-live-btn {
    animation: bounce 1500ms infinite;
  }
  .action-button {
    width: 100%;
    background: #dba23e;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS.hotButtonText};
    border: 2px solid ${COLORS.hotButtonText};
    padding: 4px 10px;
    font-size: 14px;
    small {
      font-weight: 500;
    }
  }
  #tooltip {
    background: #000;
    padding: 8px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    .tooltip-text {
      font-size: 70%;
      padding-left: 12px;
      margin: 0;
    }
  }

  .programme-wrap {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }

  .button-container {
    width: 100%;
    display: grid;
    grid-gap: 12px;
    margin: 15px 0;
  }

  .screen-container {
    width: 100%;
    height: 0;
    padding-bottom: 58.5%;
    position: relative;
  }

  .screen {
    width: 100%;
    position: absolute;
  }

  .video-container {
    width: 92%;
    height: 81%;
    background: #1e1e1e;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.5%, -51%);

    iframe {
      height: 100%;
      width: 100%;
    }
    .noStreamUrl {
      background: black;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
    }
  }

  .chat-container {
    width: 100%;
    height: 700px;
  }

  .theatre-button {
    width: 140px;
    height: 30px;
    background: black;
    margin: 6px 6px 0px 0px;
    float: right;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    opacity: 0.6;
    padding: 0;
  }

  .theatre-button-label {
    color: white;
    font-size: 12px;
    margin: 0px 10px 0px 0px;
  }

  .theatre-button-icon {
    width: 20px;
    margin: 0px 10px;
  }

  .theatre-close {
    color: white;
    background: black;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 99;
    opacity: 0.6;
  }

  .theatre-close-icon {
    width: 20px;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileAuditorium
